import Vue from 'vue'
import Vuex from 'vuex'
import eventForm from './event_form/store'
import lecturerForm from './lecturer_form/store'
import eventList from './event_list'
import eventReport from './event_report'

Vue.use(Vuex)
const debug = process.env.NODE_ENV !== 'production'

export default new Vuex.Store({
  modules: {
    eventForm,
    lecturerForm,
    eventList,
    eventReport
  },
  strict: debug
})



// WEBPACK FOOTER //
// ./src/store/index.js